import { onBuildPoints, onResolveMax } from './_chartScale';

const BLOCK = 'LStudio__app_chart';

/*
    🔥 SPARKLINE

    La línea chiquita que va DENTRO de una MetricCard o de una celda de
    tabla: sin ejes, sin grilla, sin leyenda. Solo la forma.

        <MetricCard label="Ventas" value="$ 240k"
            footer={<Sparkline values={[…]} tone="ok" />} />

    ⚠️ SIN EJES NO HAY MAGNITUD

    Una sparkline muestra la FORMA de la serie, no cuánto vale. Va
    siempre al lado de un número: sola, no informa nada.
*/

export const Sparkline = ({
    values = [], tone = 'accent',  width = 100,
    height = 28,  showArea = true,  showLast = true,  ariaLabel = 'Tendencia',
}) => {

    const CLEAN = values.map((v) => Number(v) || 0);

    if (CLEAN.length < 2) return null;

    const MAX = onResolveMax(CLEAN);

    const POINTS = onBuildPoints(CLEAN, { width, height: height - 4, max: MAX, padTop: 2 });

    const PATH = POINTS.map((p, i) => `${i === 0 ? 'M' : 'L'}${p.x},${p.y}`).join(' ');

    const AREA = `${PATH} L${width},${height} L0,${height} Z`;

    const LAST = POINTS[POINTS.length - 1];

    return (
        <svg className={`${BLOCK}_spark`} data-tone={tone}
            viewBox={`0 0 ${width} ${height}`} width={width} height={height}
            role="img" aria-label={ariaLabel} >

            {showArea && <path className={`${BLOCK}__area`} d={AREA} />}

            <path className={`${BLOCK}__line`} d={PATH} />

            {showLast && <circle className={`${BLOCK}__dot`} cx={LAST.x} cy={LAST.y} r="2.5" />}

        </svg>
    );
};
